<template>
  <div>
    <el-card shadow="nerver">
      <el-breadcrumb separator="/">
        <!-- separator 分隔符 -->
        <el-breadcrumb-item :to="{ name: 'traver_guide_config' }">POI库</el-breadcrumb-item>
        <el-breadcrumb-item>添加POI</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <el-card class="add_poi_form"
             shadow="never">
      <point-on-map @getLatLng="getLatLng"
                    ref="pointOnMap"></point-on-map>
      <div>
        <el-form :label-position="labelPosition"
                 :model="formLabelAlign"
                 label-width="180px">
          <el-form-item size="mini"
                        label="目的地:">
            <el-cascader style="width: 250px"
                         size="mini"
                         :show-all-levels="false"
                         v-model="formLabelAlign.dest"
                         :options="option"
                         :props="defaultProp"
                         clearable
                         filterable></el-cascader>
          </el-form-item>
          <el-form-item label="POI坐标:">
            经度：
            <el-input style="width: 250px"
                      size="mini"
                      v-model="formLabelAlign.location.lng"></el-input>
            纬度：
            <el-input style="width: 250px"
                      size="mini"
                      v-model="formLabelAlign.location.lat"></el-input>
          </el-form-item>
          <el-form-item label="POI名称:">
            <el-input style="width: 250px"
                      size="mini"
                      v-model="formLabelAlign.poi_name"></el-input>
          </el-form-item>
          <el-form-item label="别名（多个用英文 ,分割）:">
            <el-input style="width: 500px"
                      size="mini"
                      v-model="formLabelAlign.another_name"></el-input>
          </el-form-item>
          <el-form-item label="当地名称:">
            <el-input style="width: 500px"
                      size="mini"
                      v-model="formLabelAlign.loc_name"></el-input>
          </el-form-item>
          <el-form-item label="当地地址:">
            <el-input style="width: 500px"
                      size="mini"
                      v-model="formLabelAlign.loc_address"></el-input>
          </el-form-item>
          <el-form-item label="英文名称:">
            <el-input style="width: 500px"
                      size="mini"
                      v-model="formLabelAlign.eng_name"></el-input>
          </el-form-item>
          <el-form-item label="英文地址:">
            <el-input style="width: 500px"
                      size="mini"
                      v-model="formLabelAlign.eng_address"></el-input>
          </el-form-item>
          <el-form-item label="电话:">
            <el-input style="width: 500px"
                      size="mini"
                      v-model="formLabelAlign.mobile"></el-input>
          </el-form-item>
          <el-form-item label="网站:">
            <el-input style="width: 500px"
                      size="mini"
                      v-model="formLabelAlign.web"></el-input>
          </el-form-item>

          <!-- 社交网络 -->
          <el-form-item>
            社交：

            <el-button size="mini"
                       @click="addSnsInfor"
                       :underline="false">增加</el-button>
            <!-- <el-button size="mini" :underline="false">减少</el-button> -->
          </el-form-item>
          <el-form-item v-for="(sns, index) in formLabelAlign.sns"
                        :key="sns.index"
                        :prop="'sns.' + index + '.value'">
            <el-input style="width: 500px"
                      size="mini"
                      v-model="sns.sns_id">
              <el-select style="width: 100px"
                         v-model="sns.sns_name"
                         slot="prepend"
                         placeholder="请选择">
                <el-option label="微信"
                           value="微信"></el-option>
                <el-option label="微博"
                           value="微博"></el-option>
                <el-option label="脸书"
                           value="脸书"></el-option>
                <el-option label="Line"
                           value="Line"></el-option>
              </el-select>
            </el-input>
            <el-button v-show="index != 0"
                       size="mini"
                       style="margin-left: 10px; vertical-align: top"
                       @click.prevent="removeSns(sns)">删除</el-button>
          </el-form-item>
        </el-form>
        <!-- 提交 -->
        <el-button size="mini"
                   @click="submitPOI"
                   type="primary">提交POI</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import PointOnMap from '../../components/map/PointOnMap'
import { tpx_app, traver } from '../../network/request'
export default {
  components: {
    'point-on-map': PointOnMap,
  },
  name: 'poi_hub_add',
  data() {
    return {
      option: [], // 目的地可选项
      defaultProp: {
        multiple: false,
        checkStrictly: true,
        // emitPath: false,
        label: 'loc_name', // 指定选项标签为选项对象的某个属性值
        value: 'loc_id', // 指定选项的值为选项对象的某个属性值
        children: 'children', // 指定选项的子选项为选项对象的某个属性值
      },
      // 表单
      formLabelAlign: {
        name: '',
        dest: '', // 选择的目的地
        location: {
          lat: '',
          lng: '',
        },
        sns: [{ sns_id: '', sns_name: '' }],
      },
      labelPosition: 'top',
    }
  },
  created() {
    this.loadDest()
  },
  methods: {
    submitPOI() {
      console.log(this.formLabelAlign)
      tpx_app({
        url: '/',
        methods: 'get',
      }).then((res) => {})
    },
    loadDest() {
      this.$http.get('/get_dest_level').then((res) => {
        this.option = res.data.data
      })
    },
    handleChange() {
      console.log(this.selectDests)
      this.$refs.pointOnMap.onLoadMap()
    },
    getLatLng(lat, lng, map_source) {
      this.formLabelAlign.location.lat = lat
      this.formLabelAlign.location.lng = lng
      this.formLabelAlign.map_source = map_source
    },
    removeSns(item) {
      var index = this.formLabelAlign.sns.indexOf(item)
      if (index !== -1) {
        this.formLabelAlign.sns.splice(index, 1)
      }
    },
    addSnsInfor() {
      this.formLabelAlign.sns.push({
        sns_id: '',
        sns_name: '',
      })
    },
  },
}
</script>

<style>
#container {
  height: 100%;
  width: 100%;
}
.add_poi_form {
  margin-top: 10px;
}
</style>